module.exports = __webpack_public_path__ + "img/borrow_menu.3a48f00c.svg";